(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["atk-delivery-timeline"] && !Shopify.designMode) return;
  try {
    (function(){
  function format(date,currentYear){
    var language=document.documentElement.lang||'en';
    var option={month:'short',day:'numeric'};
    if(date.getFullYear()!==currentYear){option.year='numeric';}
    return new Intl.DateTimeFormat(language,option).format(date);
  }
  function show(){
    document.querySelectorAll('[data-atk-delivery]').forEach(function(root){
      var now=new Date(),year=now.getFullYear();
      function dateAt(days){return format(new Date(year,now.getMonth(),now.getDate()+days,12),year);}
      function opt(name){var value=Number(root.getAttribute('data-'+name));return Number.isFinite(value)?Math.max(0,Math.min(90,value)):0;}
      function windowText(from,to){var start=opt(from),end=Math.max(start,opt(to));return dateAt(start)+' – '+dateAt(end);}
      var dates={
        today:dateAt(0),
        prep:windowText('prep-start','prep-end'),
        ship:windowText('ship-start','ship-end'),
        arrive:windowText('arrive-start','arrive-end')
      };
      root.querySelectorAll('[data-atk-step]').forEach(function(el){
        var type=el.getAttribute('data-atk-step');
        if(dates[type]){el.textContent=dates[type];}
      });
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',show,{once:true});}else{show();}
  document.addEventListener('shopify:section:load',show);
  document.addEventListener('visibilitychange',function(){if(!document.hidden)show();});
  window.setInterval(show,3600000);
})();
  } catch(e) { console.error(e); }
})();

})();
